// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1qghn","main":"Layout_main__3OBIG"};